export default __webpack_public_path__ + "static/media/alerts-not-setup-dark.d365a721.png";